import { WhatsappLogo } from "@phosphor-icons/react";
import { waLink } from "@/lib/site";

export const WhatsAppFab = () => (
  <a
    href={waLink()}
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-cta"
    aria-label="WhatsApp"
    className="fixed bottom-6 right-6 z-40 flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg hover:scale-105 transition-transform no-print"
  >
    <WhatsappLogo size={30} weight="fill" />
  </a>
);
